import PropTypes from 'prop-types';
import { Button, ButtonChildren, LoadingStyled, PrependIcon } from './styled';
import loadingImg from 'assets/img/loading.png';

RButton.propTypes = {
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  prependIcon: PropTypes.any,
  type: PropTypes.string,
  variantColor: PropTypes.string,
  height: PropTypes.number,
  form: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func,
  css: PropTypes.any,
};

export function RButton({
  type = 'button',
  variant,
  variantColor,
  prependIcon,
  fullWidth,
  height = 50,
  disabled = false,
  loading = false,
  onClick = () => {},
  children,
  css,
  form,
  btnRef,
  ...rest
}) {
  return (
    <Button
      type={type}
      variant={variant}
      variantColor={variantColor}
      fullWidth={fullWidth}
      height={height}
      disabled={disabled}
      onClick={disabled || loading ? null : onClick}
      css={css}
      form={form}
      ref={btnRef}
      {...rest}
    >
      <ButtonChildren>
        {prependIcon && (
          <PrependIcon disabled={disabled}>{prependIcon}</PrependIcon>
        )}
        {loading ? <LoadingStyled src={loadingImg} alt="loading" /> : children}
      </ButtonChildren>
    </Button>
  );
}
